module.exports = __webpack_public_path__ + "static/media/swapRightOutlinedIcon.01011b31.svg";